exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".camera[data-v-7748d5f0]{z-index:10}.camera__video-container[data-v-7748d5f0]{display:none;background:#000}.camera__video-container--visible[data-v-7748d5f0]{display:block;position:fixed;top:0;left:0;right:0;bottom:0}.camera__video[data-v-7748d5f0]{position:relative;z-index:1;width:100%;height:100%}.camera .camera-action-btn[data-v-7748d5f0]{display:flex;align-items:center;justify-content:center;position:absolute;bottom:15%;left:50%;right:50%;transform:translate(-50%,-50%);z-index:10}", ""]);

// exports
